import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Link from '@/checkout-instore-legacy/components/Commons/Elements/Link'

export default function PostalCodeBar({ postalCode }) {
  if (!postalCode) {
    return null
  }
  return (
    <div className="flex pv5 ph5 f6 ph5-ns f4-ns bb b--black-20 bg-base">
      <div className="flex-auto">
        <FormattedMessage id="shippingPostalCodeBarLabel" />{' '}
        <span>{postalCode}</span>
      </div>
      <Link
        to="/shipping-postalcode"
        className="flex-none"
        intlId="shippingPostalCodeBarButton"
      />
    </div>
  )
}

PostalCodeBar.propTypes = {
  postalCode: PropTypes.string,
}
